import _ from 'lodash'
import Vue from 'vue'
// import Vue from 'vue'

export function setToken (state, token) {
  state.token = token // Probably JWT
}

export function setUser (state, user) {
  console.log('Setting User', user)
  state.user = user
}

export function setEffectiveClientAcc (state, clientAcc) {
  console.log('Setting Eff ClientAcc', clientAcc)
  state.client = clientAcc
}

export function setResellerClientAccs (state, resellerClientAccs) {
  state.resellerClientAccs = resellerClientAccs
}

export function clearAll (state) {
  state.token = null // JWT
  state.user = null
  state.client = null
}

function setProp (obj, props, value) {
  const prop = props.shift()
  if (!obj[prop]) {
    Vue.set(obj, prop, {})
  }
  if (!props.length) {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      obj[prop] = { ...obj[prop], ...value }
    } else {
      obj[prop] = value
    }
    return
  }
  setProp(obj[prop], props, value)
}


export function setUserProperty (state, payload) {
  var property = payload.propertyPath
  var value = payload.value
  // _.setWith(state.user, property, value, (nsValue, key, nsObject) => console.log(nsValue, key, nsObject))
  if (_.isString(property)) {
    Vue.set(state.user, property, value)
  } else if (_.isArray(property)) {
    setProp(state.user, property, value)
  }
}
